'use strict';

module.exports = Backbone.Model.extend({
    action: null,
    cookie: null,
    mail: null,
    name: null,
    membership: null,
    typeLogin: null,
    defaults: {
        recaptchaWidgetID: null,
        recaptchaRendered: false,
    },
    data: {},
    errors: {
        'AUTH_000': 'loginerror',
        'STA_009': 'accountblocked',
        'STA_000': 'accountblocked',
        'VAL_000': 'empty',
        'VAL_002': 'invalid',
        'VAL_003': 'invalid',
        'SSO_006': 'requesterror',
        'RCP_001': 'recaptchaError',
        'STO_000': 'remoteError',
        'default': 'requesterror',
    },

    initialize: function() {
        var cookieContent = Odigeo.Utils.readCookie('sso_remember_me');

        Odigeo._.isNull(cookieContent) && Odigeo.Utils.goToApplicationHome();

        this.cookie = decodeURIComponent(cookieContent);
        this.mail = this.cookie.split(';')[0];
        this.name = this.cookie.split(';')[1];
        this.membership = this.cookie.split(';')[2] === 'true';
        this.typeLogin = this.cookie.split(';')[3];
    },
});
